<template>
  <div>
    <div class="radio">
      <el-radio-group v-model="radio" @change="radioChange">
        <el-radio-button label="mchProductIds">Model ID</el-radio-button>
        <el-radio-button label="barcodes">Barcode</el-radio-button>
        <el-radio-button label="productNums">Article Master</el-radio-button>
      </el-radio-group>
    </div>
    <p
      v-html="language('productDetails.textareaTips')"
      style="margin-top: 20px"
    ></p>
    <p>9789866629261</p>
    <p>9789865222680</p>
    <div style="margin-top: 20px">
      <!-- :placeholder="language('productDetails.textareaTips')" -->
      <el-input
        v-model="allNums[radio]"
        type="textarea"
        :autosize="{ minRows: 20, maxRows: 35 }"
      ></el-input>
    </div>
    <div class="export">
      <el-button @click="openExport">{{
        language("productDetails.batchSearch")
      }}</el-button>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="language('productDetails.batch')"
      :visible.sync="show"
      width="90%"
      append-to-body
    >
      <template v-if="show">
        <cc-table
          :loadData="true"
          :config="table"
          :params="params"
          :refeshParams="refeshTable"
          :showIndex="false"
          method="POSTJSON"
          :headerButton="headerButton"
        ></cc-table>
      </template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      radio: "mchProductIds",
      allNums: {
        mchProductIds: "",
        barcodes: "",
        productNums: "",
      },
      shopData: {},
      show: false,
      params: {},
      refeshTable: -1,
      table: {
        api: "admin/merchant/product/queryByProductNum",
        showPager: true,
        indexFixed: "left",
        columns: [
          {
            prop: "saleStatus",
            lable: "Displayed",
            type: "tag",
            minWidth: 110,
            options: {
              1: {
                tagType: "success",
                text: this.language("productDetails.online"),
              },
              0: {
                tagType: "info",
                text: this.language("productDetails.offline"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.invisible"),
              },
              // 1: {
              //   tagType: "danger",
              //   text: "不支持线上销售",
              // },
              // 2: {
              //   tagType: "danger",
              //   text: "待上架",
              // },
            },
          },
          {
            prop: "status",
            lable: "Status",
            type: "tag",
            minWidth: 120,
            options: {
              0: {
                tagType: "info",
                text: this.language("productDetails.submit"),
              },
              1: {
                tagType: "success",
                text: this.language("productDetails.approved"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.rejected"),
              },
              // hide: {
              //   tagType: "danger",
              //   text: this.language("productDetails.hide"),
              // },
            },
          },
          {
            prop: "type",
            lable: "type",
            type: "tag",
            minWidth: 215,
            options: {
              H: {
                tagType: "success",
                text: "Non Book",
              },
              C: {
                tagType: "success",
                text: "(Book) Mainland/國版",
              },
              D: {
                tagType: "success",
                text: "(Book) HKG/港版",
              },
              E: {
                tagType: "success",
                text: "(Book) TWN/台版",
              },
              F: {
                tagType: "success",
                text: "(Book) Others/外文版",
              },
              A: {
                tagType: "success",
                text: "(Book)SUP/本版",
              },
              'DT000': {
                tagType: "success",
                text: "PRY.HK/小學教參",
              },
              "DT100": {
                tagType: "success",
                text: "SEC.HK/中學教參",
              },
              "DT200": {
                tagType: "success",
                text: "UNI.HK/大專教參",
              },
              'FT000': {
                tagType: "success",
                text: "PRY.F/外文小學教參",
              },
              "FT100": {
                tagType: "success",
                text: "SEC.F/外文中學教參",
              },
              'FT200': {
                tagType: "success",
                text: "UNI.F/外文大專教參",
              },
            },
          },
          {
            prop: "mchProductId",
            lable: "Model ID",
            minWidth: 150,
          },

          {
            prop: "barcode",
            lable: "SKU ID（Barcode）",
            minWidth: 150,
          },
          {
            prop: "productNum",
            lable: "Article Master",
            minWidth: 150,
          },
          {
            prop: "name",
            lable: "Product Name（Chi.）",
            minWidth: 180,
          },
          {
            prop: "cover",
            lable: "Product Cover",
            minWidth: 80,
            type: "img",
            urlPropName: "cover",
            sourceUrlPropName: "cover",
            // imgCompressParams: "?x-oss-process=image/resize,w_600",
            w: 40,
            h: 40,
          },
          {
            prop: "categories",
            lable: "Category（System）",
            minWidth: 120,
          },
          {
            prop: "brand",
            minWidth: 120,
            lable: "Brand",
          },
          {
            prop: "salePrice",
            lable: "Selling Price(HKD)",
            render: (rows) => {
              return this.$utils.toFixedDigit(rows.salePrice * 1, 2);
            },
            minWidth: 100,
          },
          {
            prop: "updateAdminName",
            lable: "Update By",
            minWidth: 100,
          },
          {
            prop: "updateTime",
            lable: "Last Update",
            minWidth: 200,
          },
          {
            prop: "createTime",
            lable: "Create Date",
            minWidth: 200,
          },
        ],
        buttons: [],
      },
      headerButton: [
        {
          btnName: this.language("productDetails.batchDownload") + " ",
          onClick: () => {
            let data = {
              appId: "supnr",
            };
            data[this.radio] = this.params[this.radio];
            data.shopNum = this.shopData.shopNum;
            data.mchShopNum = this.shopData.shopNum;
            console.log(data);
            this.ccRequest
              .do("admin/merchant/product/generateExportKey", data, "POSTJSON")
              .then((res) => {
                window.open(
                  process.env.VUE_APP_download +
                    "admin/merchant/product/searchExport?key=" +
                    res.data
                );
              })
              .catch((err) => {
                this.$message.error(err.response.data.message);
              });
          },
        },
      ],
    };
  },
  methods: {
    trim(str) {
      //删除左右两端的空格
      return str.replace(/(^\s*)|(\s*$)/g, "");
    },
    openExport() {
      if (this.allNums[this.radio] == "") {
        this.$message.error(this.language("productDetails.batchTips"));
        return false;
      }
      let num = this.allNums[this.radio].split(/[\s\n]/);
      let numArr = [];
      for (let index = 0; index < num.length; index++) {
        if (this.trim(num[index]) != "") {
          numArr.push(this.trim(num[index]));
        }
      }
      let data = {};
      data[this.radio] = numArr;
      data.pageNo = 1;
      data.pageSize = 1;
      data.shopNum = this.shopData.shopNum;
      data.mchShopNum = this.shopData.shopNum;
      this.ccRequest
        .do("admin/merchant/product/queryByProductNum", data, "POSTJSON")
        .then((res) => {
          if (res.total == 0) {
            this.$message.error(this.language("productDetails.emptyText"));
          } else {
            this.params = {
              shopNum: this.shopData.shopNum,
              mchShopNum: this.shopData.shopNum,
            };
            this.params[this.radio] = numArr;
            this.show = true;
          }
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    radioChange() {},
  },
  mounted() {
    this.shopData = this.$shopData;
  },
};
</script>
<style scoped>
.export {
  margin-top: 30px;
}
</style>